import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject, repeatWhen } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfirmBySmsService } from '../../../../../shared/components/modals/confirm-by-sms/confirm-by-sms.service';
import { UserLoginData } from '../login-by-sms-form/login-by-sms-form.component';
import {AuthApiService} from "../../../../../core/modules/auth/auth-api.service";
import {UserSmsLogin} from "../../../../../core/modules/auth/auth.types";

@UntilDestroy()
@Component({
  selector: 'tax-login-by-sms-authorize',
  templateUrl: 'login-by-sms-authorize.component.html',
  styleUrls: ['./login-by-sms-authorize.component.sass'],
})
export class LoginBySmsAuthorizeComponent {
  @Input() set userInfo(userInfo: UserLoginData) {
    this._userInfo = userInfo;
    this.attemptCount = userInfo.smsCodeSendResponse.params?.resendCount;
  }

  @Output() confirmed: EventEmitter<void> = new EventEmitter();

  private newCountdown: Subject<void> = new Subject();
  attemptCount?: number;
  countdown$: Observable<string> = this.confirmBySmsService.countdown$
    .pipe(repeatWhen(() => this.newCountdown));

  hasError = false;
  loading = false;
  password = '';
  _userInfo?: UserLoginData;

  constructor(
    private authApiService: AuthApiService,
    private location: Location,
    private confirmBySmsService: ConfirmBySmsService,
  ) {}

  goBack(): void {
    this.location.back();
  }

  login(userInfo: UserLoginData): void {
    const loginBySmsPayload: UserSmsLogin = {
      login: userInfo.login,
      code: this.password,
      rememberme: false,
    };

    this.hasError = false;
    this.loading = true;
    this.authApiService.loginBySms(loginBySmsPayload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.confirmed.emit();
        },
        error: () => {
          this.loading = false;
          this.hasError = true;
        },
      });
  }

  sendPasswordToUserPhone(userInfo: UserLoginData): void {
    this.hasError = false;

    this.confirmBySmsService.sendPasswordToUserPhone({
      login: userInfo.login,
    })
      .pipe(untilDestroyed(this))
      .subscribe(
        (response) => {
          this.newCountdown.next();
          this.attemptCount = response.params?.resendCount;
          this.hasError = false;
        },
      );
  }
}
